export default __webpack_public_path__ + "static/media/maximize.3190e1c7.svg";